import { useBlockProps } from "@wordpress/block-editor";

export default function Save({ attributes }) {
  const { title, description, videoUrl, weatherItems } = attributes;
  
  const blockProps = useBlockProps.save({
    className: 'weather-section-block'
  });

  return (
    <div {...blockProps}>
      <div className="bg-gray-50 p-6 md:p-8 rounded-lg border border-gray-200">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          
          {/* Video Content */}
          <div className="space-y-4">
            {title && (
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" 
                  dangerouslySetInnerHTML={{ __html: title }} />
            )}
            
            {description && (
              <p className="text-base md:text-lg text-gray-700 mb-6" 
                 dangerouslySetInnerHTML={{ __html: description }} />
            )}
            
            {videoUrl && (
              <div className="aspect-video rounded-lg overflow-hidden bg-gray-200">
                <iframe
                  src={videoUrl}
                  className="w-full h-full"
                  frameBorder="0"
                  allowFullScreen
                  title="Weather Video"
                />
              </div>
            )}
          </div>
          
          {/* Weather Items */}
          <div className="space-y-4">
            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Weather Updates</h3>
            
            {weatherItems && weatherItems.length > 0 ? (
              <div className="space-y-3">
                {weatherItems.map((item, index) => (
                  <div key={item.id || index} className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
                    {item.title && (
                      <h4 className="text-sm font-medium text-gray-900 mb-2" 
                          dangerouslySetInnerHTML={{ __html: item.title }} />
                    )}
                    
                    {item.imageUrl && (
                      <img 
                        src={item.imageUrl} 
                        className="w-full h-32 object-cover rounded"
                        alt={item.title || 'Weather image'}
                      />
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-white p-6 rounded-lg border border-gray-200 text-center">
                <p className="text-gray-500 italic">No weather updates available at this time.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}